import { IGatsbyImageData } from 'gatsby-plugin-image';

export const LOCAL_STORAGE_KEY: string = 'unikat-pk-state';

export interface AppContextProps {
  cartItems: CartItem[];
  favoriteItems: CartItem[];
  orderSentIndicator: boolean;
  addToCart: (item: CartItem) => void;
  removeFromCart: (code: number) => void;
  updateAmount: (code: number, amount: number) => void;
  addToFavorites: (item: CartItem) => void;
  updateFavoriteItemStatus: (code: number, status: string | null) => void;
  removeFromFavorites: (code: number) => void;
  handleOrderSent: () => void;
  closeOrderSentDialog: () => void;
}

export interface CartItem {
  type: string;
  name: string;
  code: number;
  image: IGatsbyImageData;
  einheitKarton: number;
  status: string | null;
  link: string;
  numOfItems: number;
}
